import produce from 'immer';
import { create } from 'zustand';

import type { WritableDraft } from 'immer/dist/internal';

import { type ProjectTeamMapping } from '../../api/projectTeamConfigurations/client-projectTeamApi';
import { type Template } from '../selectedTemplate/selectedTemplateStore';

export type ProjectTeamMappingState = {
  mappings: { [mappingKey: string]: ProjectTeamMapping };

  loadAll: (mappings: ProjectTeamMapping[]) => void;
  addOrUpdate: (mapping: ProjectTeamMapping) => void;
  delete: (mappingId: string) => void;

  loading: boolean;
  setLoading: (value: boolean) => void;

  selectedProjectTeamMappingTemplate?: Template;
  setTemplate: (template: Template | undefined) => void;
};

export const PROJECT_TEAM_MAPPINGS = create<ProjectTeamMappingState>((set) => ({
  mappings: {},
  roleMappings: {},
  moduleAssignments: {},
  overrideAssignments: {},
  relationshipOverrideAssignments: {},
  loading: false,
  selectedProjectTeamMappingTemplate: undefined,
  loadAll: (mappings: ProjectTeamMapping[]) =>
    set((state) => {
      const newState = produce(state, (draft) => {
        clearState(draft);

        mappings.forEach((mapping) => {
          addMappingToState(draft, mapping);
        });
      });

      return newState;
    }),
  addOrUpdate: (mapping: ProjectTeamMapping) =>
    set((state) => {
      const newState = produce(state, (draft) => {
        addMappingToState(draft, mapping);
      });

      return newState;
    }),
  delete: (mappingId: string) =>
    set((state) => {
      const newState = produce(state, (draft) => {
        delete draft.mappings[mappingId];
      });

      return newState;
    }),
  setLoading: (value: boolean) =>
    set((state) => {
      const newState = produce(state, (draft) => {
        draft.loading = value;
      });

      return newState;
    }),

  setTemplate: (value: Template | undefined) =>
    set((state) => {
      const newState = produce(state, (draft) => {
        draft.selectedProjectTeamMappingTemplate = value;
      });

      return newState;
    })
}));

function addMappingToState(draft: WritableDraft<ProjectTeamMappingState>, mapping: ProjectTeamMapping) {
  draft.mappings[mapping.projectTeamMappingId] = mapping;
}

function clearState(draft: WritableDraft<ProjectTeamMappingState>) {
  Object.keys(draft.mappings).forEach((key) => {
    delete draft.mappings[key];
  });
}
